import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TPostGenerateCanadianPayrollOnboardingLinkRequest } from "./postGenerateCanadianPayrollOnboardingLink.schema";

export const postGenerateCanadianPayrollOnboardingLink = (
  axios: IAxiosInstance
) => {
  return async (body: TPostGenerateCanadianPayrollOnboardingLinkRequest) => {
    const response = await axios.noRetry.post<ZealApiResponse<string>>(
      "/api/generate-canadian-payroll-onboarding-link",
      body
    );

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
